import {gql} from "@apollo/client";
export const  PRODUCT_ALL = gql`
query ProductAll($skip: Int, $first: Int) {
  product (
    skip: $skip
    orderBy: {displayText: ASC}
    first: $first,
    where: {localization: {culture_starts_with: "fa"}}
  ){
    contentItemId
    displayText
    productPickedComplementaryInfoList {
      contentItems {
        ... on ProductComplementaryInfo {
          complementaryInfoValue
          createdUtc
          complementaryInfo {
            contentItems {
              ... on ComplementaryInfo {
                id
                displayText
                parentComplementaryInfo {
                  contentItems {
                    ... on ComplementaryInfo {
                      id
                      displayText
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    productAdvantageList {
      contentItems {
        ... on ProductAdvantage {
          displayText
          htmlBody {
            html
          }
          productId {
            contentItems {
              ... on Product {
                createdUtc
                contentItemId
              }
            }
          }
        }
      }
    }
    productImageList {
      contentItems {
        ... on ProductImage {
          id
          productImage {
            urls(first: 1)
          }
        }
      }
    }
    alias {
      alias
    }
  }
}




`;

